import React from "react";
import PropTypes from "prop-types";
import AddressInfo from "../AddressInfo";
import AddressSettings from "components/AddressSettings";
import styles from "./AddressSettingsItem.module.css"; 

export function AddressSettingsItem({
  addressInfo,
  isDefault,
  isPrimary,
  onTogglePrimary,
  onSetDefault,
  onEdit,
  onDelete,
}) {

  return (
    <div className={styles.container}>
      <div className={styles.addressRow}>
        <AddressInfo addressInfo={addressInfo} />
        <div className={styles.settings}>
          <AddressSettings
            isDefault={isDefault}
            isPrimary={isPrimary}
            onDelete={onDelete}
            onTogglePrimary={onTogglePrimary}
            onEdit={onEdit}
            onSetDefault={onSetDefault}
          />
        </div>
      </div>
    </div>
  );
}

AddressSettingsItem.propTypes = {
  addressInfo: PropTypes.shape({
    country: PropTypes.string,
    address1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
  }),
  isDefault: PropTypes.bool,
  isPrimary: PropTypes.bool,
  onTogglePrimary: PropTypes.func,
  onSetDefault: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};